import { render, staticRenderFns } from "./InventoryStock.vue?vue&type=template&id=6cdedf7f&"
import script from "./InventoryStock.vue?vue&type=script&lang=js&"
export * from "./InventoryStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports